// Book deep links that carry the bettor's US state as a literal `{state}` (in the path or the host), filled only at click
// (/api/book-deep-link), and the hosts such a link may point at once filled.
export const STATE_PLACEHOLDER = '{state}';
export const STATE_HOSTS: readonly string[] = ['caesars.com', 'betrivers.com', 'bet365.com', 'betparx.com'];
const STATE_HOST = new RegExp(`^(?:.+\\.)?(?:${STATE_HOSTS.map(h => h.replaceAll('.', '\\.')).join('|')})$`, 'i');
export const isStateHost = (hostname: string): boolean => STATE_HOST.test(hostname);

// The link with `{state}` filled in, or null unless it is an https URL — to one of STATE_HOSTS when it carries the
// placeholder, so the click route can never become an open redirect.
export function fillStateLink(link: string, state: string): string | null {
  const filled = link.replaceAll(STATE_PLACEHOLDER, state);
  if (!URL.canParse(filled)) return null;
  const url = new URL(filled);
  if (url.protocol !== 'https:') return null;
  return link.includes(STATE_PLACEHOLDER) && !isStateHost(url.hostname) ? null : url.href;
}

// Whether a click could follow the link: one rule for every feed, the board and shared slips.
export const isFillableLink = (link: string): boolean => fillStateLink(link, 'xx') !== null;
